import React, { useState, useEffect } from "react";
// import { FaEdit } from "react-icons/fa"; // Removed
import axios from "axios";
import "../styles/GlobalStyles.css";

const ExperienceSection = ({
  mode = "add",           // add | edit
  initialData = null,     // data when editing
  onClose,                // close drawer
}) => {
  /* ================= STATE ================= */
  // const [experience, setExperience] = useState([]); // Removed
  const [company, setCompany] = useState("");
  const [role, setRole] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // const [totalDuration, setTotalDuration] = useState(""); // Removed
  const [editingId, setEditingId] = useState(null);

  const today = new Date().toISOString().split("T")[0];
  const isSunday = (date) => new Date(date).getDay() === 0;
const MIN_YEAR = 1970;
const MAX_EXPERIENCE_YEARS = 60;
const sanitizeText = (value) =>
  value.replace(/[^a-zA-Z\s.&-]/g, "");

  /* ================= LOAD EXPERIENCE (DASHBOARD LIST) ================= */
  useEffect(() => {
    const fetchExperience = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/profile/getCandprofile`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const raw = res.data?.candidate?.work_experience || [];

        const mapped = raw.map((job) => {
          const duration = calculateDuration(job.start_date, job.end_date);
          return {
            _id: job._id,
            company: job.organisation,
            role: job.position,
            startDate: job.start_date,
            endDate: job.end_date,
            duration,
          };
        });

        // setExperience(mapped); // Removed
        if (mapped.length > 0) {
          // setTotalDuration(calculateTotalExperience(mapped)); // Removed
        }
      } catch (err) {
        console.error("Failed to load experience", err);
      }
    };

    fetchExperience();
  }, []);

  /* ================= PREFILL FORM ON EDIT ================= */
  useEffect(() => {
    if (mode === "edit" && initialData) {
      setCompany(initialData.organisation || initialData.company || "");
      setRole(initialData.position || initialData.role || "");
      setStartDate(initialData.start_date?.split("T")[0] || initialData.startDate || "");
      setEndDate(initialData.end_date?.split("T")[0] || initialData.endDate || "");
      setEditingId(initialData._id || null);
    }
  }, [mode, initialData]);

  /* ================= HELPERS ================= */
  const calculateDuration = (start, end) => {
    if (!start || !end) return { years: 0, days: 0, totalDays: 0 };
    const diffTime = new Date(end) - new Date(start);
    if (diffTime < 0) return { years: 0, days: 0, totalDays: 0 };
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return {
      years: Math.floor(diffDays / 365),
      days: diffDays % 365,
      totalDays: diffDays,
    };
  };

const isValidYear = (date) => {
  const year = new Date(date).getFullYear();
  return year >= MIN_YEAR;
};

const exceedsMaxExperience = (start, end) => {
  const years = (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24 * 365);
  return years > MAX_EXPERIENCE_YEARS;
};


  /* ================= ADD / UPDATE EXPERIENCE ================= */
 const handleSubmit = async () => {
  if (!company || !role || !startDate || !endDate) {
    alert("Please fill all fields!");
    return;
  }

  // Sunday validation
  if (isSunday(startDate) || isSunday(endDate)) {
    alert("Dates cannot be Sundays!");
    return;
  }

  // Future date validation
  if (startDate > today || endDate > today) {
    alert("Dates cannot be in the future!");
    return;
  }

  // Year validation (prevents 1111, 1800, etc.)
  if (!isValidYear(startDate) || !isValidYear(endDate)) {
    alert(`Year must be ${MIN_YEAR} or later`);
    return;
  }

  // Start vs End validation
  if (new Date(endDate) <= new Date(startDate)) {
    alert("End date must be after Start date!");
    return;
  }

  // Unrealistic experience length
  if (exceedsMaxExperience(startDate, endDate)) {
    alert(`Experience cannot exceed ${MAX_EXPERIENCE_YEARS} years`);
    return;
  }

  try {
    const token = localStorage.getItem("token");
    if (!token) return alert("Please login");

    const payload = {
      ...(mode === "edit" && editingId ? { _id: editingId } : {}),
      job_title: role,
      position: role,
      organisation: company,
      start_date: startDate,
      end_date: endDate,
      employment_type: "Full Time",
      country: "India",
      city: "Bangalore",
      working_till_date: false,
    };

    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/profile/update/work-experience`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (onClose) onClose();
  } catch (err) {
    console.error(err);
    alert("Failed to save work experience");
  }
};



  /* ================= UI ================= */
  return (
    <div className="profile-card">
      <h2 className="page-title">Work Experience</h2>

      <div className="experience-info">
        Research says that <strong>96%</strong> recruiters look for work
        experience before downloading resumes.
      </div>

      <div className="two-col">
        <div className="form-group">
          <label className="profile-label">Job Title *</label>
          <input
  className="profile-input"
  value={role}
  onChange={(e) => setRole(sanitizeText(e.target.value))}
/>

        </div>

        <div className="form-group">
          <label className="profile-label">Organization Name *</label>
          <input
  className="profile-input"
  value={company}
  onChange={(e) => setCompany(sanitizeText(e.target.value))}
/>

        </div>
      </div>

      <div className="two-col">
        <div className="form-group">
          <label className="profile-label">Start Date *</label>
          <input
  type="date"
  min={`${MIN_YEAR}-01-01`}
  max={today}
  className="profile-input"
  value={startDate}
  onChange={(e) => setStartDate(e.target.value)}
/>

        </div>

        <div className="form-group">
          <label className="profile-label">End Date *</label>
      <input
  type="date"
  min={startDate || `${MIN_YEAR}-01-01`}
  max={today}
  className="profile-input"
  value={endDate}
  onChange={(e) => setEndDate(e.target.value)}
  disabled={!startDate}
/>


        </div>
      </div>

      <button className="save-button" onClick={handleSubmit}>
        {mode === "edit" ? "Update Experience" : "Add Experience"}
      </button>
    </div>
  );
};

export default ExperienceSection;
